// 区运会倒计时函数
export function overDateTime(time) {
    let nowTime = new Date();
    let inputTime = new Date(time);
    if (inputTime - nowTime > 0) {
        let times = (inputTime - nowTime) / 1000;
        let d = parseInt(times / 60 / 60 / 24);
        d = d < 10 ? '0' + d : d;
        let h = parseInt(times / 60 / 60 % 24);
        h = h < 10 ? '0' + h : h;
        let m = parseInt(times / 60 % 60);
        m = m < 10 ? '0' + m : m;
        let s = parseInt(times % 60);
        s = s < 10 ? '0' + s : s;
        // return d + '天' + h + '时' + m + '分' + s + '秒';
        return {
            status: 1,
            time: {
                d,
                h,
                m,
                s
            }
        }
    } else {
        return { status: 0, msg: '倒计时结束！' };
    }
}

/**
 * 区运动运动会时间
 * @param {*} startTime 开始时间
 * @param {*} endTime  结束时间
 */
export function getStartEndYDW(startTime,endTime) {
    let startTime1 = new Date(startTime);
    let endTime1 = new Date(endTime);
    let startTime2 = new Date(startTime);
    let endTime2 = new Date(endTime);
    let startTime3 = new Date(startTime);
    let endTime3 = new Date(endTime);
    let startTime4 = new Date(startTime);
    let endTime4 = new Date(endTime);
    let startTime5 = new Date(startTime);
    let endTime5 = new Date(endTime);
    let startTime6 = new Date(startTime);
    let endTime6 = new Date(endTime);
    let startTime7 = new Date(startTime);
    let endTime7 = new Date(endTime);
    let startTime8 = new Date(startTime);
    let endTime8 = new Date(endTime);
    let startTime9 = new Date(startTime);
    let endTime9 = new Date(endTime);
    let startTime10 = new Date(startTime);
}


// WEBPACK FOOTER //
// ./src/district/utils/dateTime.js